import http from "../axios";

const loginApi = {
    // 获取个人所负责省市区
  getAddress(data){
    console.log(data);
    return http({
      url: `/Principal/Regional`,
      method: "GET",
      params:data
    });
  },
}
export default loginApi;
